"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimeSelectorInput = void 0;
var _react = _interopRequireDefault(require("react"));
var _filter = _interopRequireDefault(require("lodash/filter"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _map = _interopRequireDefault(require("lodash/map"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactBootstrap = require("react-bootstrap");
var _moment = _interopRequireDefault(require("moment"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
var DropdownContainer = function DropdownContainer(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement("ul", {
    className: "time-dropdown dropdown-list",
    tabIndex: -1,
    role: "listbox",
    "aria-labelledby": "dropdown-list"
  }, children);
};
var TimeSelectorInput = exports.TimeSelectorInput = /*#__PURE__*/function (_React$Component) {
  _inherits(TimeSelectorInput, _React$Component);
  function TimeSelectorInput(props) {
    var _this;
    _classCallCheck(this, TimeSelectorInput);
    _this = _callSuper(this, TimeSelectorInput, [props]);
    _this.state = {
      show: false
    };
    _this.toggleDropdown = _this.toggleDropdown.bind(_assertThisInitialized(_this));
    _this.closeDropdown = _this.closeDropdown.bind(_assertThisInitialized(_this));
    _this.onChangeDropdown = _this.onChangeDropdown.bind(_assertThisInitialized(_this));
    _this.onKeyPress = _this.onKeyPress.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(TimeSelectorInput, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        selectedTimeIndex = _this$props.selectedTimeIndex,
        hasError = _this$props.hasError,
        validFn = _this$props.validFn;
      if (hasError && prevProps.selectedTimeIndex !== selectedTimeIndex) {
        validFn();
      }
    }
  }, {
    key: "onChangeDropdown",
    value: function onChangeDropdown(event) {
      var _this2 = this;
      var onChangeHandler = this.props.onChangeHandler;
      var target = event.target;
      var value = target.getAttribute('data-value');
      onChangeHandler(value, function () {
        _this2.setState({
          show: false
        });
      });
    }
  }, {
    key: "onKeyPress",
    value: function onKeyPress(event) {
      event.preventDefault();
      event.stopPropagation();
      if (13 === event.keyCode) {
        if (-1 !== event.target.tabIndex) {
          this.onChangeDropdown(event);
        }
      }
      if (40 === event.keyCode && event.target.nextElementSibling) {
        event.target.nextElementSibling.focus();
      }
      if (38 === event.keyCode && event.target.previousElementSibling) {
        event.target.previousElementSibling.focus();
      }
    }
  }, {
    key: "toggleDropdown",
    value: function toggleDropdown() {
      var _this3 = this;
      var show = this.state.show;
      var toggle = function toggle() {
        _this3.setState({
          show: !show
        });
      };
      return toggle();
    }
  }, {
    key: "closeDropdown",
    value: function closeDropdown() {
      this.setState({
        show: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$props2 = this.props,
        label = _this$props2.label,
        placeholder = _this$props2.placeholder,
        selectedTimeIndex = _this$props2.selectedTimeIndex,
        selectDisabled = _this$props2.selectDisabled,
        htmlId = _this$props2.htmlId,
        hasError = _this$props2.hasError,
        inputRef = _this$props2.inputRef,
        timeData = _this$props2.timeData,
        errorMessage = _this$props2.errorMessage,
        buttonStyle = _this$props2.buttonStyle,
        intl = _this$props2.intl;
      var show = this.state.show;
      var disabledColor = selectDisabled ? {
        color: '#c6c6c6'
      } : {};
      var parseTimeIndex = parseInt(selectedTimeIndex, 10);
      var selectedTime = (0, _filter.default)(timeData, {
        time_index: parseTimeIndex
      })[0] || {};
      var dropdownDiplayValue = selectedTime && selectedTime.time ? intl.formatTime((0, _moment.default)(selectedTime.time, 'LT').format()) : placeholder;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "dropdown-container"
      }, label ? /*#__PURE__*/_react.default.createElement("label", {
        className: "time-label",
        htmlFor: "".concat(htmlId)
      }, label, " ") : '', /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("button", {
        id: "".concat(htmlId),
        type: "button",
        className: "btn dropdown-btn btn-block text-gray-dark ".concat(hasError ? 'border-error' : ''),
        style: _objectSpread(_objectSpread({}, disabledColor), buttonStyle),
        onClick: this.toggleDropdown,
        disabled: selectDisabled,
        ref: function ref(_ref2) {
          if (inputRef) return inputRef(_ref2);
          _this4.target = _ref2;
          return _this4.target;
        },
        "aria-haspopup": "listbox",
        "aria-expanded": show,
        "data-value": !(0, _isEmpty.default)(selectedTime) ? selectedTimeIndex : ''
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "dropdown-value ellipsis"
      }, dropdownDiplayValue), /*#__PURE__*/_react.default.createElement("span", {
        className: "down-arrow"
      })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Overlay, {
        show: show,
        rootClose: true,
        onHide: function onHide() {
          return _this4.setState({
            show: false
          });
        },
        placement: "bottom",
        animation: false,
        container: this,
        target: this.target
      }, /*#__PURE__*/_react.default.createElement(DropdownContainer, {
        style: {
          top: '42px'
        }
      }, (0, _map.default)(timeData, function (value) {
        var timeIndex = value.time_index,
          time = value.time;
        var rxKey = "".concat(htmlId, "-").concat(timeIndex);
        var selected = timeIndex === parseTimeIndex;
        var formattedTime = intl ? intl.formatTime((0, _moment.default)(time, 'LT').format()) : time;
        return /*#__PURE__*/_react.default.createElement("li", {
          onClick: _this4.onChangeDropdown,
          onKeyDown: _this4.onKeyPress,
          role: "option",
          "aria-label": time,
          className: "".concat(selected ? 'selected' : ''),
          "aria-selected": selected,
          key: rxKey,
          "data-value": timeIndex,
          tabIndex: 0
        }, formattedTime);
      })))), hasError ? /*#__PURE__*/_react.default.createElement("p", {
        className: "help-block inline-help text-danger text-left"
      }, errorMessage) : '');
    }
  }]);
  return TimeSelectorInput;
}(_react.default.Component);
DropdownContainer.propTypes = {
  children: _propTypes.default.array
};
TimeSelectorInput.propTypes = {
  label: _propTypes.default.string,
  placeholder: _propTypes.default.string.isRequired,
  onChangeHandler: _propTypes.default.func.isRequired,
  selectDisabled: _propTypes.default.bool,
  htmlId: _propTypes.default.string.isRequired,
  selectedTimeIndex: _propTypes.default.number,
  hasError: _propTypes.default.bool,
  inputRef: _propTypes.default.func,
  timeData: _propTypes.default.array,
  errorMessage: _propTypes.default.string,
  validFn: _propTypes.default.func,
  buttonStyle: _propTypes.default.object
};